import { apiSlice } from 'store/slices/api/api-slice';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        personageActive: builder.mutation({
            query: (personageId: string) => ({
                url: `/personage/activate/` + personageId,
                method: 'PATCH',
                header: {},
            }),
        }),
    }),
});

export const { usePersonageActiveMutation } = importTradeDataApiSlice;
